import { CreatableOption, MultiSelectProps, SingleSelectProps, OptionTypeWithCode } from '../../types';
import { isObject } from '../../../../utils/guards';

export function isMultiSelect<VALUE>(
  props: MultiSelectProps<VALUE> | SingleSelectProps<VALUE>
): props is MultiSelectProps<VALUE> {
  return (props as MultiSelectProps<VALUE>).multiple;
}

export function isCreatableOption(option?: unknown): option is CreatableOption {
  return !!option && isObject(option) && !!(option as CreatableOption).creatableValue;
}

export function isOptionTypeWithCode<OPTION extends OptionTypeWithCode>(option?: unknown): option is OPTION {
  return !!option && isObject(option) && !!(option as CreatableOption).label;
}
